import React from 'react';
import { Stack } from '@chakra-ui/react';
import TallyMarks from './TallyMarks';

const TallyMarkControl = ({ used, total, verticleOrientation = false }) => {
  const numGroups = Math.ceil(total / 5);

  const tallyGroups = Array.from({ length: numGroups }, (_, index) => {
    const groupTotal = Math.min(5, total - index * 5);
    const groupUsed = Math.max(0, Math.min(5, used - index * 5));
    return { used: groupUsed, total: groupTotal };
  });

  return (
    <Stack
      direction={verticleOrientation ? 'column' : 'row'}
      spacing={0}
      position="relative"
    >
      {tallyGroups.map((group, index) => (
        <TallyMarks key={index} used={group.used} total={group.total} />
      ))}
    </Stack>
  );
};
export default TallyMarkControl;
